import TabInfo from '../../../common/TabController/TabInfo';
import NewScreen from './NewScreen';
import ScreeningJobs from './ScreeningJobs';
import ScreeningResults from './ScreeningResults';

const tabs = [
    new TabInfo(
        'new_screen_tab',
        'New Screen',
        NewScreen,
        {
            TabPanelProps: { sx: { p: 1 } }, // override padding level
        }
    ),
    new TabInfo(
        'screen_jobs_tab',
        'Screening Jobs',
        ScreeningJobs,
        {
            TabPanelProps: { sx: { p: 1 } }, // override padding level
        }
    ),
    new TabInfo(
        'screen_results_tab',
        'Screening Results',
        ScreeningResults,
        {
            TabPanelProps: {
                style: {
                    flex: 1,
                    flexDirection: 'column',
                },
                sx: { p: 1 }, // override padding level
            },
        }
    ),

];
export default tabs;
